export function spellingMismatchIndexes(answer: string, expected: string) {
  const normalizedAnswer = answer.normalize("NFC").trim().replace(/\s+/g, " ").toLocaleLowerCase("en");
  return new Set([...expected].flatMap((character, index) =>
    character.toLocaleLowerCase("en") === normalizedAnswer[index] ? [] : [index]));
}

type StudyKeyboardCommand = "advance" | "reveal" | "forgot" | "remembered";

export function studyKeyboardCommand(
  event: Pick<KeyboardEvent, "altKey" | "code" | "ctrlKey" | "key" | "metaKey" | "repeat">,
  stage: "introduction" | "recall" | "feedback" | "completion",
  recallRevealed = false,
): StudyKeyboardCommand | null {
  if (event.repeat || event.altKey || event.ctrlKey || event.metaKey) return null;
  const advances = event.key === "Enter" || event.code === "Space";
  if (stage === "recall") {
    if (!recallRevealed) return advances ? "reveal" : null;
    if (event.key === "1") return "forgot";
    if (event.key === "2") return "remembered";
    return null;
  }
  return advances ? "advance" : null;
}
